export default "__VITE_ASSET__CzFVnAhn__"